var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 39.9999H34.6666V45.3333H29.3333V39.9999ZM29.3333 18.6666H34.6666V34.6666H29.3333V18.6666ZM31.9733 5.33325C17.2533 5.33325 5.33325 17.2799 5.33325 31.9999C5.33325 46.7199 17.2533 58.6666 31.9733 58.6666C46.7199 58.6666 58.6666 46.7199 58.6666 31.9999C58.6666 17.2799 46.7199 5.33325 31.9733 5.33325ZM31.9999 53.3333C20.2133 53.3333 10.6666 43.7866 10.6666 31.9999C10.6666 20.2133 20.2133 10.6666 31.9999 10.6666C43.7866 10.6666 53.3333 20.2133 53.3333 31.9999C53.3333 43.7866 43.7866 53.3333 31.9999 53.3333Z",
    fill: "#C8C8C8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorWarning);
export default __webpack_public_path__ + "static/media/error-warning.82df8416.svg";
export { ForwardRef as ReactComponent };